import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./Style/index.scss"
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store/store";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import 'bootstrap/dist/css/bootstrap.min.css';


const root = ReactDOM.createRoot(document.getElementById("root"));
// const options = {
//   // passing the client secret obtained from the server
//   clientSecret: '{{CLIENT_SECRET}}',
// };

//const stripePromise = loadStripe('pk_test_TYooMQauvdEDq54NiTphI7jx');
const stripePromise = loadStripe('pk_test_1234567890abcdef');

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Elements
        stripe={stripePromise}

      // options={options}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Elements>
    </Provider>
  </React.StrictMode>
);
